import styled from 'styled-components';

import { Tabs } from '../../common/FileTabs';
import { alpha } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { tabActions } from '@store/slices';
import { State } from '@store/index';

const TOP_NAVBAR_HEIGHT = 60;

const Container = styled.div`
  align-items: center;
  display: grid;
  flex: 0 0 auto;
  height: ${() => `${TOP_NAVBAR_HEIGHT}px`};
  color: ${({ theme }) => theme.text.standard};
  grid-template-columns: 1fr auto auto;
`;

const ServiceMenu = styled.div<{ largeName?: boolean }>`
  display: grid;
  grid-template-columns: auto 7fr auto;
  align-items: center;
  height: ${() => `${TOP_NAVBAR_HEIGHT - 1}px`};
  border-bottom: 1px solid ${({ theme }) => theme.background.standard};
  user-select: none;

  && ::-webkit-scrollbar {
    height: 4px;
    width: 4px;
    background: ${({ theme }) => theme.background.standard};
  }

  && ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.text.subtext};
  }

  && ::-webkit-scrollbar-thumb:hover {
    background: black;
  }

  .control {
    display: flex;
    align-items: center;
    height: ${() => `${TOP_NAVBAR_HEIGHT - 1}px`};
    border: 0;
    color: ${({ theme }) => theme.text.standard};
    padding: 0 28px;
    padding-top: 4px;
    background-color: ${({ theme }) => theme.background.standard};
    border-right: 1px solid ${({ theme }) => theme.line.light};
    max-width: calc(300px - 8px);
    /* min-width: ${({ largeName }) => (largeName ? 'calc(300px)' : 'unset')}; */

    font-family: 'PPFormula';

    h3 {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .tabs {
    display: flex;
    height: ${() => `${TOP_NAVBAR_HEIGHT - 1}px`};
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.line.light};
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }

  .menu-bar {
    display: flex;
    height: 100%;
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.line.light};
    max-width: 30vw;
    height: ${() => `${TOP_NAVBAR_HEIGHT - 1}px`};
    padding: 0 1rem;
    /* border-left: 1px solid ${({ theme }) => theme.line.light}; */
  }
`;

const ServiceMenuTab = styled(ServiceMenu)<{ isFlow?: boolean }>`
  border-bottom: 1px solid ${({ theme, isFlow }) => (isFlow ? theme.line.light : theme.background.standard)};

  .control {
    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => alpha(theme.primary, 0.06)};
    }
  }

  /* .menu-bar {
    border-bottom: 0;
  } */
`;

const Page = styled.div`
  display: grid;
  grid-template-columns: auto 1fr; // Updated this line
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.line.light};
  z-index: 100;
  height: ${() => `${TOP_NAVBAR_HEIGHT}px`}; // Added height for consistency

  .title {
    display: flex;
    align-items: center;
    padding: 0 28px;
    gap: 0.5rem;
    padding-right: 32px;
    user-select: none;
    height: ${() => `${TOP_NAVBAR_HEIGHT}px`}; // Added height for consistency

    svg {
      font-size: 20px;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    height: ${() => `${TOP_NAVBAR_HEIGHT - 1}px`};
  }

  h3 {
    color: ${({ theme }) => theme.text.standard};
    font-size: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

interface Props {
  header?: string;
  actions?: React.ReactNode;
}

export const TopNavbar: React.FC<Props> = ({ header, actions }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const last_menu = useSelector((state: State) => state.tabs.last_menu);
  const trace = useSelector((state: State) => state.tabs.active.run);

  const { service_id, workflow_id } = useParams();

  const isHome = Boolean(!service_id);
  const isServiceMenu = Boolean(service_id && !workflow_id);
  const isLargeName = Boolean(header && header.length > 18);

  if (isHome) {
    return (
      <Container>
        <Page>
          <div className='title'>
            {/* <HouseOutlined /> */}
            <h3>{header}</h3>
          </div>
          <div className='actions'>{typeof actions === 'object' && actions}</div>
        </Page>
      </Container>
    );
  }

  if (isServiceMenu) {
    return (
      <Container>
        <ServiceMenu largeName={isLargeName}>
          <button
            className='control'
            disabled={trace?.running}
            onClick={() => {
              navigate(last_menu || `/${service_id}/workflow`);
              dispatch(tabActions.reset());
            }}
          >
            <h3>{header}</h3>
          </button>
          <div className='tabs'>
            <Tabs />
          </div>
          <div className='menu-bar'>{typeof actions === 'object' && actions}</div>
        </ServiceMenu>
      </Container>
    );
  }

  return (
    <Container>
      <ServiceMenuTab
        largeName={isLargeName}
        isFlow={Boolean(location?.pathname?.includes('/workflow/') && workflow_id)}
      >
        <button
          className='control'
          disabled={trace?.running}
          onClick={() => {
            navigate(last_menu || `/${service_id}/workflow`);
            dispatch(tabActions.reset());
          }}
        >
          <h3>{header}</h3>
        </button>
        <div className='tabs'>
          <Tabs />
        </div>
        <div className='menu-bar'>{typeof actions === 'object' && actions}</div>
      </ServiceMenuTab>
    </Container>
  );
};
